export const getFilenameParts = (file: string): { filename: string; extension: string } => {
  const parts = file.split('.');
  return { filename: parts.slice(0, -1).join('.'), extension: parts.pop() || '' };
};
